import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { TicketDetailInitStepDeclaration } from "./Steps/TicketDetailInitStep";

export const TicketDetailStartupFlow = new FlowDefinition("TicketDetailFlow");

TicketDetailStartupFlow.addStep(TicketDetailInitStepDeclaration);

TicketDetailStartupFlow.setStartStep("TicketDetailInit_Step");

export const ticketDetailStartupFlowDefinition = new StepDefinition({
    stepName: "TicketDetailFlow",
    stepFlow: TicketDetailStartupFlow,
    contextIsolation: false
})